module.exports = __webpack_public_path__ + "static/media/SFProText-RegularItalic.90ad050f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-RegularItalic.ttf
// module id = 2549
// module chunks = 7